import React from 'react';

import { upgradeModal } from 'components/common/CheckPermissions/UpgradeSubscriptionModal';

const CustomCentreNameFallback = ({ currentCentreId, centreName, isBlur }) => {
  const onClickValue = () => {
    upgradeModal.open(null, currentCentreId);
  };
  return (
    <div onClick={onClickValue} role="presentation" className="cursor-pointer">
      <span className={isBlur ? 'blur' : ''}>{centreName}</span>
    </div>
  );
};

export default CustomCentreNameFallback;
